module.exports = __webpack_public_path__ + "static/media/Sigal Vainapel.381c8cb9.png";